import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/Navigation/navigation.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(public navigationService:NavigationService) { }

  ngOnInit(): void {
  }
  
}
